"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OffchainLookupSenderMismatchError = exports.OffchainLookupResponseMalformedError = exports.OffchainLookupError = void 0;
const stringify_js_1 = require("../utils/stringify.js");
const base_js_1 = require("./base.js");
const utils_js_1 = require("./utils.js");
class OffchainLookupError extends base_js_1.BaseError {
  constructor(_ref) {
    var _cause$metaMessages;
    let {
      callbackSelector,
      cause,
      data,
      extraData,
      sender,
      urls
    } = _ref;
    super(cause.shortMessage || 'An error occurred while fetching for an offchain result.', {
      cause,
      metaMessages: [...(cause.metaMessages || []), (_cause$metaMessages = cause.metaMessages) !== null && _cause$metaMessages !== void 0 && _cause$metaMessages.length ? '' : [], 'Offchain Gateway Call:', urls && ['  Gateway URL(s):', ...urls.map(url => "    ".concat((0, utils_js_1.getUrl)(url)))], "  Sender: ".concat(sender), "  Data: ".concat(data), "  Callback selector: ".concat(callbackSelector), "  Extra data: ".concat(extraData)].flat()
    });
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'OffchainLookupError'
    });
  }
}
exports.OffchainLookupError = OffchainLookupError;
class OffchainLookupResponseMalformedError extends base_js_1.BaseError {
  constructor(_ref2) {
    let {
      result,
      url
    } = _ref2;
    super('Offchain gateway response is malformed. Response data must be a hex value.', {
      metaMessages: ["Gateway URL: ".concat((0, utils_js_1.getUrl)(url)), "Response: ".concat((0, stringify_js_1.stringify)(result))]
    });
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'OffchainLookupResponseMalformedError'
    });
  }
}
exports.OffchainLookupResponseMalformedError = OffchainLookupResponseMalformedError;
class OffchainLookupSenderMismatchError extends base_js_1.BaseError {
  constructor(_ref3) {
    let {
      sender,
      to
    } = _ref3;
    super('Reverted sender address does not match target contract address (`to`).', {
      metaMessages: ["Contract address: ".concat(to), "OffchainLookup sender address: ".concat(sender)]
    });
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'OffchainLookupSenderMismatchError'
    });
  }
}
exports.OffchainLookupSenderMismatchError = OffchainLookupSenderMismatchError;
//# sourceMappingURL=ccip.js.map